import { axiosCallerPlugin } from 'src/plugins/axios/componentAxiosCallerPlugin';
import { useLoggingStore } from 'src/stores/logging';
import { of } from 'rxjs';
import { tap, switchMap, catchError, filter, map } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
const QueryVideoPlugin = (appType, userType, listingId, loading, dataCallback) => {
    const loggingStore = useLoggingStore();
    const { subject: showVideo$ } = rxInitSubjectCallback();
    const { axiosCall } = axiosCallerPlugin();
    const urlMap = {
        getspaces: {
            'user': 'user_manage_space_2',
            'host': 'host_dashboard'
        },
        getproperty: {
            'user': 'space_ad',
            'host': 'space_ad'
        }
    };
    const appUrlMap = {
        'getspaces': 'view_space_video',
        'getproperty': 'view_video'
    };
    useObservable(showVideo$.pipe(switchMap((v) => {
        return of(v).pipe(switchMap(() => {
            return axiosCall({
                url: `${urlMap[appType][userType]}/${listingId}/${appUrlMap[appType]}`,
                urlType: appType === 'getspaces'
                    ? 'spaces_core'
                    : 'spaces_ad',
                type: 'list',
                alert: false,
                loading: loading.value
            });
        }), catchError((err) => {
            loggingStore.errorHandler(err);
            return of({ success: false, data: null });
        }));
    }), filter((v) => v.success), filter((v) => v.data !== null), map((v) => v.data), map(({ results }) => results), map((v) => {
        return v.map((item) => {
            // support legacy and standardize
            if (item.space_img_url) {
                item.url = item.space_img_url;
            }
            if (item.space_img_sequence) {
                item.sequence = item.space_img_sequence;
            }
            if (item.space_img_caption) {
                item.caption = item.space_img_caption;
            }
            if (item.space_img_content_type) {
                item.content_type = item.space_img_content_type;
            }
            const videoUrlSplit = item.url.split('/');
            const thumbnailUrl = `https://i.ytimg.com/vi/${videoUrlSplit[videoUrlSplit.length - 1]}/hqdefault`;
            return {
                ...item,
                thumbnail: thumbnailUrl,
            };
        });
    }), tap((v) => {
        dataCallback(v);
    })));
    return {
        showVideo$
    };
};
export { QueryVideoPlugin };
